import { createContext, useContext } from "react";

/**
 * Permissões da sessão. Hoje só uma: quem pode EXCLUIR.
 *
 * Criar, ler e editar continuam liberados para todo mundo — apagar registro é
 * exclusivo de administrador (o cargo/checkbox "Administrador" do Portal). Quem
 * não pode não vê o botão: descobrir a regra levando um 403 depois de confirmar
 * a exclusão é o tipo de coisa que vira chamado.
 */
const Ctx = createContext(false);

export const PermissoesProvider = Ctx.Provider;

/** Só administradores podem excluir registros (regra do Portal). */
export const usePodeExcluir = () => useContext(Ctx);
